'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthority$() {
  this.aHi = null;
  this.aHj = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthority$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthority$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthority$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthority$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthority$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthority$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthority$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthority$.prototype = $p;
$p.aA = (function() {
  if ((!this.aHj)) {
    this.aHi = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aHj = true;
  }
  return this.aHi;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthority$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthority$, "app.data.data_point_types$package$CertificateOfOriginAuthority$", ({
  Fw: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthority$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthority$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthority$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthority$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthority$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthority$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthority$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthority$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthority$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthority$ };
//# sourceMappingURL=app.data.data_point_types$package$-Certificate-Of-Origin-Authority$.js.map
